import type { Deployment, DiffPull } from "@rebuild/shared";

function commitsMatch(a: string | null, b: string | null): boolean {
	if (!a || !b) return false;
	const left = a.toLowerCase();
	const right = b.toLowerCase();
	return left === right || left.startsWith(right) || right.startsWith(left);
}

export function findDeploymentForPull(pr: DiffPull, stagingHistory: Deployment[]): Deployment | null {
	const prNumber = String(pr.number);
	return stagingHistory.find((deployment) => (
		commitsMatch(deployment.commitSha, pr.mergeCommitSha) || deployment.prId === prNumber
	)) ?? null;
}

export function findDeploymentForPullInTimeline(
	pr: DiffPull,
	newestFirstPulls: DiffPull[],
	stagingHistory: Deployment[],
	prIndex: number,
): Deployment | null {
	const directMatch = findDeploymentForPull(pr, stagingHistory);
	if (directMatch) return directMatch;

	const selectedMergedAt = new Date(pr.mergedAt).getTime();
	const nextNewerMergedAt = prIndex > 0 ? new Date(newestFirstPulls[prIndex - 1].mergedAt).getTime() : Number.POSITIVE_INFINITY;
	if (!Number.isFinite(selectedMergedAt)) return null;

	return stagingHistory.find((deployment) => {
		if (!deployment.artifactRef) return false;
		const deployedAt = new Date(deployment.createdAt).getTime();
		return deployedAt >= selectedMergedAt && deployedAt < nextNewerMergedAt;
	}) ?? null;
}

export function getIncludedPullsForDeploy(newestFirstPulls: DiffPull[], selectedIndex: number): DiffPull[] {
	if (selectedIndex < 0 || selectedIndex >= newestFirstPulls.length) return [];
	return newestFirstPulls.slice(selectedIndex);
}
